<template>
    <div>
        <div class="" style="background: #FAFAFA; padding-bottom: 30px;">
            <div class="container">
                <div class="d-flex justify-content-between align-items-baseline">
                    <h3 class="bills-text"><span class="fa fa-chevron-left" @click="goback()"></span>Electricity</h3>
                    <h5 class="history-text" @click="routeTo('/dashboard/bills-history')">History</h5>
                </div>

                <div>
                    <div class="provider-holder">
                        <div class="custom-dropdown">
                            <label for="provider">Service providers</label>
                            <div class="selected-option" @click.stop="togglePanelProvider">
                                <img :src="selectedImg" alt="" id="current-flag">
                                <span id="current-name">{{ optionData == '' ? 'Select Provider': optionData }}</span>
                                <!-- <span><i class="fa fa-chevron-right"></i></span> -->
                            </div>

                            <!-- The hidden panel of countries -->
                            <ul class="options-panel" id="provider" v-if="providerPanel" >
                                <li @click="selectProvider(`${item.label}`)" v-for="(item, index) in processedList"
                                    :key="index">
                                    <img :src="item.url" alt=""> {{item.label}} Electricity
                                </li>
                            </ul>
                        </div>
                        <hr>
                    </div>
                    <div class="provider-holder pt-0">
                        <div class="custom-dropdown">
                            <label for="package">Package</label>
                            <div class="selected-option" @click.stop="togglePanelPackage">
                                <img :src="selectedImg" alt="" id="current-package">
                                <span id="current-name">{{ package == '' ? 'Select package': package }}</span>
                            </div>

                            <!-- The hidden panel of countries -->
                            <ul class="options-panel" id="package" v-if="packagePanel && optionData != ''">
                                <li @click="selectPackage('PREPAID')">
                                    <img :src="selectedImg" alt=""> PREPAID
                                </li>
                                <li @click="selectPackage('POSTPAID')">
                                    <img :src="selectedImg" alt=""> POSTPAID
                                </li>
                                
                            </ul>
                        </div>
                        <hr>
                        <div class="form-group">
                            <div class="beneficiries">
                                <label for="meterNumber">Meter number</label>
                                <span data-toggle="modal" data-target="#beneficiaryList" @click="checkBeneficaries()">Beneficiaries <i class="fa fa-cheveron-right"></i></span>
                            </div>
                            <div class="verify-meter">
                                <input v-model="meterNumber" type="number" id="meterNumber" class="form-control" placeholder="Meter number"></input>
                                <button :disabled="package == '' || optionData == '' || meterNumber == '' || loading" class="btn" @click="verifyMeterNumber(); finalCheck = false;">
                                    <span v-if="!loading">Validate</span>
                                    <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="loading"
                                    ></i>
                                </button>
                            </div>
                            <div class="verify-data">
                                <h4>{{verifiedData.name}}</h4>
                            </div>
                            <div class="ben-holder">
                                <!-- <input type="checkbox" id="savebeneficiaris" class="form-control" true-value="yes"
                                    false-value="no" v-model="savebeneficiary"> -->
                                <label for="savebeneficiaris" @click="saveBeneficiaryDetails()" style="cursor: pointer;">Save Beneficiary</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="amount-holder">
                    <div class="selected-amount">
                        <label for="choose-amount">Choose Amount</label>
                        <div class="amount-box" id="choose-amount">
                            <div class="amount-item" @click="selectedAmountValue(1000)">₦1,000</div>
                            <div class="amount-item" @click="selectedAmountValue(2000)">₦2,000</div>
                            <div class="amount-item" @click="selectedAmountValue(5000)">₦5,000</div>
                            <div class="amount-item" @click="selectedAmountValue(10000)">₦10,000</div>
                            <div class="amount-item" @click="selectedAmountValue(15000)">₦15,000</div>
                            <div class="amount-item" @click="selectedAmountValue(20000)">₦20,000</div>
                            <div class="amount-item" @click="selectedAmountValue(30000)">₦30,000</div>
                            <div class="amount-item" @click="selectedAmountValue(40000)">₦40,000</div>
                            <div class="amount-item" @click="selectedAmountValue(50000)">₦50,000</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="amount">Amount</label>
                        <input type="text" id="amount" class="form-control" placeholder="Amount" v-model="formattedAmount">
                    </div>
                    <div class="form-group pt-5">
                        <label for="phonenumber">Phone number</label>
                        <input type="number" id="phonenumber" class="form-control" placeholder="Enter phone number" v-model="phoneNumber">
                    </div>
                </div>

                <div class="payment-method-holder">
                    <label for="paymentmethod">Select Payment Method</label>
                    <div class="paymentOfPayment" id="paymentmethod">
                        <div class="" style="position: relative;">
                            <!-- <div class="payment-item col-md-6" @click="paymentType = 'paystack'" :class="[paymentType == 'paystack' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/paystack.svg" alt="paystack">
                                <h6>Pay with Paystack</h6>
                            </div> -->
                            <div class="payment-item col-md-6" @click="paymentType = 'safe'" :class="[paymentType == 'safe' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/safe-logo.svg" alt="safe">
                                <div>
                                    <h6>Pay with SAFE</h6>
                                    <p>Available balance: <span>₦{{Number(safeDetails.balance || 0).toLocaleString()}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="submitPayment">
                        <button class="btn" @click="openConfirmation(); finalCheck = true">Pay Now</button>
                    </div>
                    <confirmPayment @call-parent="buyElectricity" ref="confirmModalBill"   />
                    <succesfulPayment :billdata="billObject" @call-parent="buyElectricity" ref="successfulPaymentMade"  />
                </div>
            </div>

            <!-- Beneficiary List -->
            <div class="modal fade" id="beneficiaryListId" tabindex="-1" role="dialog" aria-labelledby="beneficiaryListId" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="exampleModalLongTitle">Beneficiaries</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group" v-if="beneficiaries.length > 0">
                            <ul>
                                <li>Select beneficiary</li>
                                <li  v-for="(item, index) in beneficiaries" @click.stop="selectBeneficiary(item)"
                              :key="index">{{ item.bill_identifier }}</li>
                            </ul>
                        </div>
                        <p v-else>
                            No beneficiary added.
                        </p>
                    </div>
                    
                    </div>
                </div>
            </div>
            <!-- Beneficiary List -->
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
// import paystack from "vue-paystack";
import PageLoader from "../../components/PageLoader.vue";
// import { staticdata } from "../../src/data";
const Api = new Service();
import $ from "jquery";
import confirmPayment from './ConfirmPayment.vue';
import succesfulPayment from './SuccessfulPayment.vue';
    export default {
        name: "Electricity",
        components: {
            confirmPayment,
            succesfulPayment,
            PageLoader
        },
        data() {
            return {
                loading: false,
                selectedImg: "",
                imgScr: "",
                optionData: "",
                package: "",
                providerPanel: false,
                packagePanel: false,
                amount: 0,
                paymentType: "",
                billObject: {},
                network: "",
                phoneNumber: "",
                meterNumber: "",
                vendor_type: "",
                coverPoint: 0,
                savebeneficiary: 'no',
                electricityDiscos: [],
                discoTrimed: "",
                verifiedData: "",
                statutoryCharge: null,
                finalCheck: false,
                beneficiaries: [],
                beneficiarySelected: "",
                rewardObject: "",
                safeDetails: "",
            }
        },
        computed: {
            formattedAmount: {
                get() {
                    if (!this.amount) return '';
                    return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                },
                set(value) {
                    // remove commas before storing
                    this.amount = value.replace(/,/g, '');
                }
            },
            processedList() {
                if (!this.electricityDiscos || this.electricityDiscos.length === 0) return [];
                return this.electricityDiscos.map((item, index) => {
                    let fileName = '';
                    // Example of 8+ conditions
                    if (item === 'ABUJA') {
                        fileName = 'AEDC.svg';
                    } 
                    else if (item === 'EKO') {
                        fileName = 'EKEDC.svg';
                    } 
                    else if (item === 'IKEJA') {
                        fileName = 'IE.svg';
                    } 
                    else if (item === 'IBADAN') {
                        fileName = 'IBEDC.svg';
                    } 
                    else if (item === 'ENUGU') {
                        fileName = 'EEDC.svg';
                    } 
                    else if (item === 'PH') {
                        fileName = 'PHED.svg';
                    } 
                    else if (item === 'JOS') {
                        fileName = 'JEDC.svg';
                    } 
                    else if (item === 'KADUNA') {
                        fileName = 'KE.svg';
                    } 
                    else if (item === 'YOLA') {
                        fileName = 'YEDC.svg';
                    }
                    else if (item === 'KANO') {
                        fileName = 'KAEDC.svg';
                    }
                    // require() must include a static prefix to help Webpack find the folder
                    return {
                        label: item,
                        url: require(`../../assets/billpayment/${fileName}`)
                    };
                });
            },
        },
        mounted() {
            // Add listener when component is mounted
            document.addEventListener('click', this.close);
            document.addEventListener('click', this.close2);
            this.fetchDiscos();
            setTimeout(() => {
                // When this updates, processedList() triggers immediately
                this.processedList();
            }, 1000);
            this.getBeneficiary();
            this.fetchReward();
        },
        beforeDestroy() {
            // Crucial: remove listener to prevent memory leaks
            document.removeEventListener('click', this.close);
            document.removeEventListener('click', this.close2);
        },
        methods: {
            getImage(item, index) {
                let fileName = 'AEDC.svg';

                if (item === 'ABUJA') {
                        fileName = 'AEDC.svg';
                } 
                else if (item === 'EKO') {
                    fileName = 'EKEDC.svg';
                } 
                else if (item === 'IKEJA') {
                    fileName = 'IE.svg';
                } 
                else if (item === 'IBADAN') {
                    fileName = 'IBEDC.svg';
                } 
                else if (item === 'ENUGU') {
                    fileName = 'EEDC.svg';
                } 
                else if (item === 'PH') {
                    fileName = 'PHED.svg';
                } 
                else if (item === 'JOS') {
                    fileName = 'JEDC.svg';
                } 
                else if (item === 'KADUNA') {
                    fileName = 'KE.svg';
                } 
                else if (item === 'YOLA') {
                    fileName = 'YEDC.svg';
                }
                else if (item === 'KANO') {
                    fileName = 'KAEDC.svg';
                }
                // Must include a static part of the path for Webpack to find the folder
                return require(`../../assets/billpayment/${fileName}`);
                
            },
            // imgScr(item) {
            //     // We reuse the same logic to get the correct URL
            //     this.selectedImg = this.resolveImage(item, index);
            // },
            routeTo(route) {
                this.$router.push({
                path: route
                })
                .catch(() => {});
            },
            goback() {
                window.history.length > 1 ? this.$router.back() : this.$router.push('/dashboard/bills-payment')
            },
            async fetchDiscos() {
                this.loading = true
                try {
                    await Api.getRequest(`fetch-buy-power-discos`)
                    .then(res => {
                    this.loading = false;
                    // console.log("discos fetched", res)
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                    if (res.data.success) {
                        this.electricityDiscos = res.data.discos;
                    }
                    })
                    .catch(err => {
                        console.log("ERROR", err);
                        this.loading = false;
                    });
                } finally {
                // console.log("Closed connection");
                }
            },
            saveBeneficiaryDetails() {
                if (this.meterNumber == '') {
                    return this.$store.commit("setApiFailed", "Enter meter number");
                }
                Api.postRequest(`save-user-bill-data`, {
                    bill_type: "electricity",
                    bill_identifier: this.meterNumber,
                }).then((res) => {
                    // this.$store.commit("setApiSuccess", "Beneficiary added successfuly");
                    console.log("beneficiary saved", res);
                }).catch(err => {
                    console.log("ERROR", err);
                    this.loading = false;
                });
            },
            getBeneficiary() {
                Api.postRequest(`fetch-user-bill-data-by-bill-type`, {type: 'electricity'}).then((res) => {
                    
                    if(res.data.success) {
                        // console.log("fetch beneficiary", res);
                        const duplicated = res.data.data;
                        // this.beneficiaries = [...new Set(duplicated)];
                        this.beneficiaries = [...new Map(duplicated.map(item => [item.bill_identifier, item])).values()]
                    }
                }).catch(err => {
                    console.log("ERROR", err);
                });
            },
            checkBeneficaries() {
                $("#beneficiaryListId")
                    .addClass("fade")
                    .modal("show");
            },
            selectBeneficiary(item) {
                this.meterNumber = item.bill_identifier;
                this.$nextTick(() => {
                    $('#beneficiaryListId').modal('hide');
                });
            },
            async buyElectricity(messageFromParent) {
                this.loading = true
                $("#confirmPaymentBill")
                .removeClass("fade")
                .modal("hide");
                this.loading = true
                let str = this.optionData;
                let spaceIndex = str.indexOf(" ");
                let targetIndex = str.indexOf("Electricity");
                if (spaceIndex !== -1 && targetIndex !== -1) {
                    this.discoTrimed = str.slice(0, spaceIndex) + str.slice(targetIndex + "Electricity".length);
                // console.log(result.trim());
                }
                let payData = {
                    mode_of_payment: this.billObject.paymentMethod,
                    vend_type: this.package,
                    meter_no: this.meterNumber,
                    disco: this.discoTrimed.trim(),
                    phone: this.phoneNumber,
                    statutory_charge: this.statutoryCharge,
                    amount: Number(this.amount),
                    cova_points: this.coverPoint,
                }
                try {
                    await Api.postRequest(`pay-for-electricity`, JSON.stringify(payData))
                    .then(res => {
                        // console.log("Electricity response:", res)
                        if(res.data.requery == 'yes') {
                            this.loading = true;
                            return this.requery(res.data.requery_id)
                        }
                        this.loading = false;
                        if (res.data.error) {
                            return this.$store.commit("setApiFailed", res.data.error);
                        }
                        if (res.data.success) {
                            this.loading = false;
                            this.billsHook();
                            this.$store.commit("setApiSuccess", "success");
                            res.data.data.payment_type = this.paymentType;
                            res.data.data.transaction_type = 'Electricity';
                            res.data.data.purchasePhone = this.phoneNumber;
                            res.data.data.meter_number = this.meterNumber; 
                            res.data.data.vend_type = this.package; 
                            res.data.data.statutory_charge = this.statutoryCharge;
                            res.data.data.customerName = this.verifiedData.name;
                            res.data.data.address = this.verifiedData.address;
                            res.data.data.reward = this.rewardObject;
                            this.$root.$refs.openSuccess.openSuccessModal();
                            this.$refs.successfulPaymentMade.setDataSuccess(res.data);
                            this.statutoryCharge = null;
                        }
                    })
                    .catch(err => {
                        console.log("ERROR", err);
                        this.loading = false;
                    });
                } finally {
                // console.log("Closed connection");
                }
            },
            async requery(requeryId) {
                this.loading = true
                try {
                    await Api.getRequest(`requery-bill/${requeryId}`)
                    .then(res => {
                    this.loading = false;
                    if(res.data.requery == 'yes') {
                        this.loading = true;
                        return this.requery(res.data.requery_id)
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                    if (res.data.success) {
                        this.loading = false;
                        this.billsHook();
                        this.$store.commit("setApiSuccess", "success");
                        // res.data.data.payment_type = this.paymentType;
                        // res.data.data.transaction_type = 'Airtime';
                        // res.data.data.purchasePhone = this.phoneNumber;
                        // this.sendingSuccessfulData = res.data;
                        // this.$root.$refs.openSuccess.openSuccessModal();
                        // this.$refs.successfulPaymentMade.setDataAirtime(res.data); 

                        res.data.data.payment_type = this.paymentType;
                        res.data.data.transaction_type = 'Electricity';
                        res.data.data.purchasePhone = this.phoneNumber;
                        res.data.data.meter_number = this.meterNumber; 
                        res.data.data.vend_type = this.package; 
                        res.data.data.statutory_charge = this.statutoryCharge;
                        res.data.data.customerName = this.verifiedData.name;
                        res.data.data.address = this.verifiedData.address;
                        res.data.data.reward = this.rewardObject;
                        this.$root.$refs.openSuccess.openSuccessModal();
                        this.$refs.successfulPaymentMade.setDataSuccess(res.data);
                    }
                    })
                    .catch(err => {
                        // this.loader2 = false;
                        this.loading = false;
                    });
                } finally {
                // console.log("Closed connection");
                }
            },
            billsHook() {
                Api.getRequest(`bills-hook`).then((res) => {
                }).catch(err => {
                    this.loading = false;
                });
            },
            async verifyMeterNumber() {
                if (this.meterNumber == "") {
                    return this.$store.commit("setApiFailed", "Enter meter number");
                }
                if (this.package == "") {
                    return this.$store.commit("setApiFailed", "Select package");
                }
                if (this.billObject == "") {
                    return this.$store.commit("setApiFailed", "Select disco");
                }
                this.loading = true;
                let str = this.optionData;
                let spaceIndex = str.indexOf(" ");
                let targetIndex = str.indexOf("Electricity");
                if (spaceIndex !== -1 && targetIndex !== -1) {
                    this.discoTrimed = str.slice(0, spaceIndex) + str.slice(targetIndex + "Electricity".length);
                // console.log(result.trim());
                }
                let payData = {
                    meter_no: this.meterNumber,
                    vend_type: this.package,
                    disco: this.discoTrimed
                }
                try {
                    await Api.postRequest(`fetch-meter-details`, JSON.stringify(payData))
                        .then(res => {
                            // console.log("Meter verification", res)
                            this.loading = false;
                            if (res.data.error) {
                                this.verifiedData = "";
                                return this.$store.commit("setApiFailed", res.data.error);
                            }
                            if (res.data.success) {
                                this.verifiedData = res.data.data;
                                this.statutoryCharge = res.data.statutory_charge;
                                if(this.finalCheck == true) {
                                    this.confirmatiomModalValidation();
                                } else {
                                    this.$store.commit("setApiSuccess", "success");
                                }
                                
                            }
                        })
                        .catch(err => {
                            console.log("ERROR", err);
                            this.loading = false;
                        });
                } finally {
                        // console.log("closed") 
                }
            },
            selectProvider(title, srcImg) {
                // const fullPath = srcImg;
                // const filename = fullPath.split('/').pop(); 
                this.optionData = title + ' Electricity';
                // this.imgScr = require( `../../assets/billpayment/${filename}`);

                this.selectedImg = this.getImage(title);
            },
            togglePanelProvider() {
                this.providerPanel = !this.providerPanel;
            },
            close(e) {
                // Check if the click was outside this component's root element
                if (this.$el.contains(e.target)) {
                    this.providerPanel = false;
                }
            },
            selectPackage(item) {
                this.package = item;
            },
            togglePanelPackage() {
                this.packagePanel = !this.packagePanel;
            },
            close2(e) {
                // Check if the click was outside this component's root element
                if (this.$el.contains(e.target)) {
                    this.packagePanel = false;
                }
            },
            selectedAmountValue(selectedmount) {
                this.amount = selectedmount;
            },
            async openConfirmation() {
                if (this.statutoryCharge == null) {
                    await this.verifyMeterNumber();
                }
                else {
                    this.confirmatiomModalValidation();
                }
            },
            confirmatiomModalValidation() {
                if (this.meterNumber == '') {
                    return this.$store.commit("setApiFailed", "Enter meter number");
                }
                if (this.amount == '') {
                    return this.$store.commit("setApiFailed", "Choose data type");
                }
                if (this.optionData == '') {
                    return this.$store.commit("setApiFailed", "Select disco");
                }
                if (this.package == '') {
                    return this.$store.commit("setApiFailed", "Select package");
                }
                else {
                    this.billObject.amount = Number(this.amount);
                    this.billObject.paymentType = "Electricity"
                    this.billObject.paymentMethod = "safe";
                    this.billObject.vend_type = this.package;
                    this.billObject.statutory_charge = this.statutoryCharge;
                    this.billObject.phone = this.phoneNumber;
                    this.billObject.meter_no = this.meterNumber;
                    this.billObject.cover_points = this.coverPoints;
                    this.billObject.disco = this.optionData;
                    this.billObject.customerName = this.verifiedData.name;
                    this.billObject.address = this.verifiedData.address;
                    this.billObject.reward = this.rewardObject;
                    this.$refs.confirmModalBill.setDataSuccess(this.billObject); 
                    // this.$refs.successfulPaymentMade.setDataAirtime(this.billObject); 
                    this.$root.$refs.openConfirm.openConfirmationModal();
                }
            },
            async fetchReward() {
                try {
                    await Api.getRequest(`shelta-rewards`).then(res => {
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                    if (res.data.success) {
                    this.rewardObject = res.data;
                    this.fetchSafeData();
                    }
                    })
                    .catch(err => {
                        console.log("ERROR", err)
                        // this.loader2 = false;
                        this.loading = false;
                    });
                } finally {
                // console.log("Closed connection");
                }
            },
            async fetchSafeData() {
                try {
                    await Api.getRequest(`fetchsafedata`)
                    .then(res => {
                        if (res.data.success) {
                            this.safeDetails = res.data;   
                        }
                        if (res.data.error) {
                        this.$store.commit("setApiFailed", "Can not read safe data");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
                } finally {
                    // console.log("Closed connection");
                }
            }, 
        },
    }
    
</script>


<style scoped lang="scss">
.bills-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    color: #1A1A1A;
    margin-top: 40px;
    span {
        font-size: 18px;
        margin-right: 20px;
        cursor: pointer;
    }
}

.history-text {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 60px;
    color: #4688F4;
    cursor: pointer;
    margin-top: 40px;

}

.ben-holder {
    display: flex;
    align-items: center;
    margin-top: 10px;
    label {
        margin-bottom: 0;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #9CA3AF;

    }
}
#savebeneficiaris {
    height: 17px;
    width: 17px;
    margin-right: 10px;
    cursor: pointer;
}
.verify-meter {
    position: relative;
    button {
        position: absolute;
        top: 10px;
        right: 8px;
        background: #0033EA;
        color: #Ffff;
        height: 30px;
        padding: 2px 15px;
        outline: 0;
        box-shadow: none;
    };
}

ul {
  list-style-type: none;
  margin: 10px;
  padding: 10px;
  height: 100px;
  overflow: scroll;
  li {
    font-family: Lato;
    font-size: 14px;
    color: #555555;
    cursor: pointer;
    padding: 10px;
  }
}
ul li:nth-child(odd) {
  background-color: #ffffff; /* Color for odd rows */
}

ul li:nth-child(even) {
  background-color: #f2f2f2; /* Color for even rows */
}


label {
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #555555;
    text-align: left;
    display: flex;
}

select {
    box-shadow: none !important;
    outline: 0 !important;
    height: 48px;
    border: none;
    padding-left: 0;
    font-family: Lato;
    font-weight: 500;
    color: #555555;
    font-size: 16px;
    

}

.verify-data {
    margin-top: 6px;
    margin-bottom: 20px;
    h4 {
        font-family: Lato;
        text-align: left;
        color: #555555;
        font-size: 16px;
        font-weight: 600;
    }
}

.provider-holder {
    background: #ffffff;
    padding: 24px 8px 16px 8px;
    border-radius: 12px;
}


.custom-dropdown {
  position: relative;
//   width: 250px;
}

.selected-option {
  padding: 10px;
  border: 1px solid #E6E9EC;;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 4px;
  font-family: Lato;
  font-weight: 500;
  font-size: 14px;
}

.options-panel {
//   display: none; /* Hidden by default */
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;

  font-family: Lato;
  font-weight: 500;
  font-size: 16px;

}

.options-panel li {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.options-panel li:hover {
  background-color: #f0f0f0;
}

/* Class to show the panel */
.show {
  display: block;
}

input {
    height: 48px;
    border-radius: 4px;
//   border: 1px solid #e7e7e7;
    border: 1px solid #ccc;
    background: #F8F9FA !important;
    border: none;
//   color: #aaadba;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    outline: 0 !important;
    box-shadow: none !important;
}
.beneficiries {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    span {
        color: #555555;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
    }
}

.amount-holder, .payment-method-holder {
    background: #ffffff;
    padding: 24px 8px 16px 8px;
    border-radius: 12px;
    margin-top: 30px;
}

.amount-box {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    
}
.amount-item {
    background: #F8F9FA;
    padding: 12px 8px;
    border-radius: 8px;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
}
.amount-item:hover {
    background: #e5e5e6;
}

.amount-item:not(:last-child) {
    margin-right: 15px;
}

.paymentOfPayment {
    // display: flex;
    margin-top: 30px;
}
.payment-item {
    display: flex;
    align-items: center;
    border: 1px solid #E6E9EC;
    padding: 16px;
    gap: 8px;
    border-radius: 6px;
    height: 75px;
    margin-bottom: 10px;
    cursor: pointer;
    // width: 50%;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 17px;
        // line-height: 100%;
       color: #1A1A1A;
        text-align: left;
        margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 15px;
        // line-height: 100%;
        color: #555555;
        text-align: left;
        margin-bottom: 0;
        span {
            color: #4688F4;
        }
    }
}
.payment-item:hover {
    border: 1px solid #0033EA;
}
.active-payment {
    border: 1px solid #0033EA;
}

.submitPayment {
    margin-top: 40px;
    button {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        width: 100%;
        height: 48px;
        outline: 0;
        box-shadow: none;
    }
}

/* For Chrome, Safari, Edge, and Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; /* Removes a small margin in older Chrome versions */
}

/* For Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/* Optional: Combine into a class for specific inputs */
.no-spinners::-webkit-outer-spin-button,
.no-spinners::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spinners {
    -moz-appearance: textfield;
    appearance: textfield; /* Standard property (works in newer browsers) */
}

@media only screen and (max-width: 599px) {
    .verify-meter {
        button {
            padding: 2px 6px;
            font-size: 12px
        };
    }
}

</style>